import React, { Component } from "react";
import PromotionDetails from "./promotions_details";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getDirectoryShow } from "../../../actions/directory_shows";
import { fetchCategoryShows } from "../../../action_managers/show_search";
import get from "lodash/get";
import { showModal } from "../../../actions/modal";
import { INVITE_DIRECTORY_SHOW } from "../../modals/modal_root";

class PromotionsDirectoryShowDetails extends Component {
  componentDidMount() {
    this.props.getDirectoryShow(this.getDirectoryShowUUID()).then(response => {
      if (response.status === 200) {
        this.props.fetchCategoryShows(
          get(response, "json.ShowRequest.categoryUUIDs"),
          this.getDirectoryShowUUID()
        );
      }
    });
  }

  getDirectoryShow = () => {
    return get(this.props.directoryShows, this.getDirectoryShowUUID());
  };
  getDirectoryShowUUID = () => {
    return this.props.match.params.directoryShowUUID;
  };

  render() {
    return (
      <PromotionDetails
        buttonText={"Invite to RedCircle"}
        handleClick={() => this.props.showDirectoryInviteModal(this.getDirectoryShow())}
        show={this.getDirectoryShow()}
        isLoading={this.props.categoryShows.isLoading}
        categoryShows={this.props.categoryShows}
        shouldDisableButton={false}
      />
    );
  }
}

export default withRouter(
  connect(
    ({ browsePromotion, directoryShows }) => ({
      categoryShows: browsePromotion.categoryShows,
      directoryShows,
    }),
    {
      getDirectoryShow,
      fetchCategoryShows,
      showDirectoryInviteModal: directoryShow =>
        showModal(INVITE_DIRECTORY_SHOW, { directoryShow }),
    }
  )(PromotionsDirectoryShowDetails)
);
